// src/store/actions/entityActions.js
import { ENTITY_ACTIONS } from './actionTypes';
import entityService from '../../services/entityService';

// Fetch entities
export const fetchEntities = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: ENTITY_ACTIONS.FETCH_ENTITIES_REQUEST });

    const response = await entityService.getEntities(params);
    
    dispatch({
      type: ENTITY_ACTIONS.FETCH_ENTITIES_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: ENTITY_ACTIONS.FETCH_ENTITIES_FAILURE,
      payload: error.message || 'Failed to fetch entities',
    });
  }
};

// Fetch single entity
export const fetchEntity = (id) => async (dispatch) => {
  try {
    dispatch({ type: ENTITY_ACTIONS.FETCH_ENTITY_REQUEST });

    const response = await entityService.getEntityById(id);
    
    dispatch({
      type: ENTITY_ACTIONS.FETCH_ENTITY_SUCCESS,
      payload: response,
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: ENTITY_ACTIONS.FETCH_ENTITY_FAILURE,
      payload: error.message || 'Failed to fetch entity',
    });
    throw error;
  }
};

// Create entity
export const createEntity = (entityData) => async (dispatch) => {
  try {
    dispatch({ type: ENTITY_ACTIONS.CREATE_ENTITY_REQUEST });

    const response = await entityService.createEntity(entityData);
    
    dispatch({
      type: ENTITY_ACTIONS.CREATE_ENTITY_SUCCESS,
      payload: response,
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: ENTITY_ACTIONS.CREATE_ENTITY_FAILURE,
      payload: error.message || 'Failed to create entity',
    });
    throw error;
  }
};

// Update entity
export const updateEntity = (id, entityData) => async (dispatch) => {
  try {
    dispatch({ type: ENTITY_ACTIONS.UPDATE_ENTITY_REQUEST });

    const response = await entityService.updateEntity(id, entityData);
    
    dispatch({
      type: ENTITY_ACTIONS.UPDATE_ENTITY_SUCCESS,
      payload: response,
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: ENTITY_ACTIONS.UPDATE_ENTITY_FAILURE,
      payload: error.message || 'Failed to update entity',
    });
    throw error;
  }
};

// Delete entity
export const deleteEntity = (id) => async (dispatch) => {
  try {
    dispatch({ type: ENTITY_ACTIONS.DELETE_ENTITY_REQUEST });

    const response = await entityService.deleteEntity(id);
    
    dispatch({
      type: ENTITY_ACTIONS.DELETE_ENTITY_SUCCESS,
      payload: { id, message: response.message },
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: ENTITY_ACTIONS.DELETE_ENTITY_FAILURE,
      payload: error.message || 'Failed to delete entity',
    });
    throw error;
  }
};

// Toggle entity status
export const toggleEntityStatus = (id) => async (dispatch) => {
  try {
    dispatch({ type: ENTITY_ACTIONS.TOGGLE_ENTITY_STATUS_REQUEST });

    const response = await entityService.toggleEntityStatus(id);
    
    dispatch({
      type: ENTITY_ACTIONS.TOGGLE_ENTITY_STATUS_SUCCESS,
      payload: response,
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: ENTITY_ACTIONS.TOGGLE_ENTITY_STATUS_FAILURE,
      payload: error.message || 'Failed to toggle entity status',
    });
    throw error;
  }
};

// Upload entity image
export const uploadEntityImage = (id, imageFile) => async (dispatch) => {
  try {
    dispatch({ type: ENTITY_ACTIONS.UPLOAD_ENTITY_IMAGE_REQUEST });

    const response = await entityService.uploadEntityImage(id, imageFile);
    
    dispatch({
      type: ENTITY_ACTIONS.UPLOAD_ENTITY_IMAGE_SUCCESS,
      payload: response,
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: ENTITY_ACTIONS.UPLOAD_ENTITY_IMAGE_FAILURE,
      payload: error.message || 'Failed to upload image',
    });
    throw error;
  }
};

// Fetch entity products
export const fetchEntityProducts = (entityId, params = {}) => async (dispatch) => {
  try {
    dispatch({ type: ENTITY_ACTIONS.FETCH_ENTITY_PRODUCTS_REQUEST });

    const response = await entityService.getEntityProducts(entityId, params);
    
    dispatch({
      type: ENTITY_ACTIONS.FETCH_ENTITY_PRODUCTS_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: ENTITY_ACTIONS.FETCH_ENTITY_PRODUCTS_FAILURE,
      payload: error.message || 'Failed to fetch entity products',
    });
  }
};

// Fetch entity agencies
export const fetchEntityAgencies = (entityId, params = {}) => async (dispatch) => {
  try {
    dispatch({ type: ENTITY_ACTIONS.FETCH_ENTITY_AGENCIES_REQUEST });

    const response = await entityService.getEntityAgencies(entityId, params);
    
    dispatch({
      type: ENTITY_ACTIONS.FETCH_ENTITY_AGENCIES_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: ENTITY_ACTIONS.FETCH_ENTITY_AGENCIES_FAILURE,
      payload: error.message || 'Failed to fetch entity agencies',
    });
  }
};

// Bulk delete entities
export const bulkDeleteEntities = (ids) => async (dispatch) => {
  try {
    dispatch({ type: ENTITY_ACTIONS.BULK_DELETE_ENTITIES_REQUEST });

    const response = await entityService.bulkDeleteEntities(ids);
    
    dispatch({
      type: ENTITY_ACTIONS.BULK_DELETE_ENTITIES_SUCCESS,
      payload: response,
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: ENTITY_ACTIONS.BULK_DELETE_ENTITIES_FAILURE,
      payload: error.message || 'Failed to bulk delete entities',
    });
    throw error;
  }
};

// Set entity filters
export const setEntityFilters = (filters) => ({
  type: ENTITY_ACTIONS.SET_ENTITY_FILTERS,
  payload: filters,
});

// Clear error
export const clearEntityError = () => ({
  type: ENTITY_ACTIONS.CLEAR_ENTITY_ERROR,
});

// Clear success
export const clearEntitySuccess = () => ({
  type: ENTITY_ACTIONS.CLEAR_ENTITY_SUCCESS,
});

// Clear selected entity
export const clearSelectedEntity = () => ({
  type: ENTITY_ACTIONS.CLEAR_SELECTED_ENTITY,
});